import classNames from 'classnames';
import { forwardRef } from 'react';

import type { InputProps } from './types';
import './input.scss';

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, invalid, ...restProps }, ref) => {
  return (
    <input ref={ref} className={classNames('payflow-ui input', invalid && 'has-error', className)} {...restProps} />
  );
});
